import React from 'react';
import PropTypes from 'prop-types';
import Globe from './Icons/Globe.jsx';
import TrendingUp from './Icons/TrendingUp.jsx';
import './IconButton.scss';

const iconMap = {
  globe: <Globe />,
  trendingUp: <TrendingUp />,
};

const IconButton = ({ classNames, onClick, icon, text, disabled, style }) => (
  <button
    className={`toggleVistype ${classNames}${disabled ? ' disabled' : ''}`}
    onClick={onClick}
    type="button"
    disabled={disabled}
    style={style}
  >
    {icon ? iconMap[icon] : <></>}
    {text}
  </button>
);

IconButton.propTypes = {
  classNames: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string,
  text: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
};

IconButton.defaultProps = {
  classNames: '',
  icon: '',
  text: '',
  style: {},
  disabled: false,
};

export default IconButton;
